<template>
  <div class="post-card" @click="selectPost">
    <div class="post-image">
      <img :src="post.coverImg | ossImageProcess" @load="loadImage"/>
      <icon v-if="!disableSelect && post.selected" class="selected-icon" id="selected-icon"/>
    </div>
    <div class="title"> {{post.title}}</div>
    <div class="detail">
      <div class="post-by">
        <img :src="post.postedBy.avatar" class="avatar"/>
        <span class="name">{{post.postedBy.name}}</span>
      </div>
    </div>
    <div class="time">
      {{post.postTime}}
    </div>
  </div>
</template>

<script>
import Icon from '@/components/icon';

export default {
  components: {
    Icon
  },
  props: {
    post: { type: Object },
    disableSelect: { type: Boolean, default: false }
  },
  methods: {
    loadImage(e) {
      const width = e.target.width;
      const height = e.target.height;
      if (width > height) {
        e.target.style.width = 'auto';
        e.target.style.height = '100%';
      } else {
        e.target.style.height = 'auto';
        e.target.style.width = '100%';
      }
    },
    selectPost () {
      this.$emit('selected');
    },
  }
}
</script>

<style lang="scss" scoped>
$width: 164px;
$selectedIconFontSize: 36px;
.post-card {
  .post-image {
    min-height: 150px;
    max-height: 213px;
    width: $width;
    height: 150px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;

    .selected-icon {
      position: absolute;
      top: calc(50% - #{ $selectedIconFontSize / 2});
      font-size: $selectedIconFontSize;
    }
  }
  .title {
    width: $width;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .detail {
    display: flex;
    margin-top: 6px;
    .post-by {
      font-size: 12px;
      .avatar {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        -o-object-fit: fill;
        object-fit: fill;
        vertical-align: middle;
      }
      .name {
        font-size: 12px;
        margin-left: 8px;
      }
    }
  }
  .time {
    margin-top: 6px;
    font-size: 10px;
  }
}
</style>
